<template>
  <div class="container mx-auto text-center p-6">
    <h1 class="text-3xl font-bold mb-6">Corporate Membership</h1>
    <p class="text-lg">Perfect for companies looking to provide golfing benefits to employees.</p>
  </div>
</template>

<style scoped>
.container {
  max-width: 800px;
}
</style>
